import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/src/components/Button/Button.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/EventListingItem/EventListingItem.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(entrix)/[lang]/events/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/ListingItem/ListingItem.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Listing/Listing.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["SortDropdown"] */ "/app/src/components/ListingPage/SortDropdown/SortDropdown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/app/src/components/Nav/Nav.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Prose/Prose.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Pagination/Pagination.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ListingPage/FilterBar/FilterBar.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/ListingPage/ListingPage.module.css");
